import { FC } from 'react'

import { Main } from '../../components/Main'

import './styles.scss'

const HomeScreen: FC = () => {
  return <Main ariaLabelledby="Home">ADMIN TENANT</Main>
}

export default HomeScreen
